<template>
    <div class="not-found-page">
        <div class="card">
            <div class="emoji">🀄</div>
            <h1>404</h1>
            <p class="subtitle">找不到此頁面</p>
            <p class="desc">你所輸入的連結不存在或已失效。</p>
            <a href="/" class="home-btn">返回主頁</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotFoundPage',
}
</script>

<style scoped>
    .not-found-page {
        min-height: 100vh;
        background: linear-gradient(135deg, #f0fdf4 0%, #e8f5e9 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    }

    .card {
        background: white;
        border-radius: 24px;
        padding: 48px 36px;
        text-align: center;
        box-shadow: 0 12px 40px rgba(0,0,0,0.07);
        max-width: 360px;
        width: 100%;
        border-top: 4px solid #4CAF50;
    }

    .emoji {
        font-size: 52px;
        margin-bottom: 12px;
        line-height: 1;
    }

    h1 {
        font-size: 64px;
        font-weight: 800;
        color: #e0e0e0;
        margin: 0 0 8px;
        line-height: 1;
    }

    .subtitle {
        font-size: 20px;
        font-weight: 700;
        color: #333;
        margin: 0 0 10px;
    }

    .desc {
        font-size: 14px;
        color: #999;
        margin: 0 0 28px;
        line-height: 1.6;
    }

    .home-btn {
        display: inline-block;
        background: #4CAF50;
        color: white;
        text-decoration: none;
        padding: 12px 32px;
        border-radius: 12px;
        font-size: 15px;
        font-weight: 600;
        box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
        transition: all 0.2s;
    }

    .home-btn:hover {
        background: #43a047;
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4);
    }

    .home-btn:active {
        transform: scale(0.97);
    }
</style>
